// Minimal, elegant heraldic crest — thin-line shield to sit beside the Cinzel wordmark.
// Uses currentColor so it inherits white / light-grey from its container.
export const CrestIcon = ({ className = "" }) => (
  <svg viewBox="0 0 32 36" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true" focusable="false">
    <path d="M16 2.5 L28.5 7.5 V17.5 C28.5 26.5 22.5 31.8 16 34 C9.5 31.8 3.5 26.5 3.5 17.5 V7.5 Z" stroke="currentColor" strokeWidth="1.1" strokeLinejoin="round" />
    <path d="M3.5 12.5 H28.5" stroke="currentColor" strokeWidth="1" opacity="0.65" />
    <path d="M16 16 L18.4 20 L16 24 L13.6 20 Z" stroke="currentColor" strokeWidth="1" strokeLinejoin="round" />
    <path d="M16 24 V29" stroke="currentColor" strokeWidth="1" opacity="0.55" strokeLinecap="round" />
  </svg>
);

export default CrestIcon;
